import { json, jsonRpc, middleware, xray, fetch, bodyOnly } from '@ux/drivers';
import * as r from 'ramda';

export default () => r.compose(middleware(), bodyOnly(), jsonRpc(), json(), xray())(fetch);
